<template>
    <div id="works">
        <h2 id="titWork">WORKS</h2>
        <p class="baja">Websites, apps, statistical graphics and infographics.</p>
        <div id="divSel">
            <ul id="selec" @click="act = !act" :class="{ open: act }">
                <li v-for="(sel, index) in orderSeccs" :key="sel.id" class="opt" @click="cambia(sel)" :style="{ order: orderSel(sel, index) }">{{ sel }}</li>
            </ul>
        </div>
        <ul id="ulWorks">
            <li v-for="info in dataWorks" :key="info.id" class="stepLi" v-show="ver(este, info.seccion)" :id="'info'+info.id" :data-info="info.id" ref="secondSteps">
                <a class="linkLi" href="" @click.prevent="cambiarId(info.id)" target="_blank">
                    <div class="conteLi">
                        <div class="contImg">
                            <video v-if="info.video" autoplay loop muted>
                                <source :src="require(`@/assets/img/vid/`+ info.imagen)" type="video/mp4">
                                Your browser does not support the video tag.</video>
                            <img v-else :src="require(`@/assets/img/infos/`+ info.imagen)" :alt="info.imagen">
                        </div>
                        <div class="contText">
                            <h3 class="titu">{{ info.titulo }}</h3>
                            <a class="link" :href="info.link" target="_blank">+</a>
                            <!-- <div class="base">
                            </div> -->
                        </div>
                    </div>
                </a>
            </li>
        </ul>
    </div>
</template>
<script>

import ScrollReveal from 'scrollreveal'
export default {
    
    props: {
        dataWorks: {
            type: Array,
            default: () => []
        },
        // dataDetalles: {
        //     type: Array,
        //     default: () => []
        // },
        seccs: {
            type: Array,
            default: () => []
        },
        skills: {
            type: Array,
            default: () => []
        },        
    },
    data(){
        return {
            separa: [],
            orden: [],
            este: 'All works',
            act: false,
            activeIndex: -1,
            esteId: null,
            // abre: false,
        }
    },
    // components: {
    //     Detalles,
    // },
    // created() {
    //     this.$nextTick(() => {
    //         // const steps = Array.isArray(this.$refs.secondSteps) 
    //         // ? this.$refs.secondSteps 
    //         // : [this.$refs.secondSteps];
    //         let steps = document.querySelectorAll('stepLi')
    //         let arrSteps = Array.from(steps)
    //         console.log('arrSteps', arrSteps);
    
    //         const observerW = new IntersectionObserver(this.handleIntersect, {
    //             root: null, // Usa la ventana como contenedor
    //             threshold: 0.5, // El elemento es visible al 50%
    //             step: '#ulWorks .step'
    //         });
            
    //         // Observar cada elemento
    //         arrSteps.forEach((step) => {
    //             if (step instanceof Element) {
    //                 observerW.observe(step);
    //             } else {
    //                 console.warn("Un elemento no es válido para observar:", step);
    //             }
    //         });
    //     });
    // },
    created() {
        this.initScrollReveal();
    },
    computed: {
        orderSeccs(){
            let seccs = this.seccs
            let orden = seccs.sort(function (a, b) {
                if (a < b) {
                    return -1;
                }
                if (a > b) {
                    return 1;
                }
                return 0;
                });
            return orden
        }
    },
    methods: {
        // botonCierra(close){
        //     this.abre = close // manda false desde Detalles.vue
        // },
        cambiarId(id){
            // console.log('ID', id);
            // this.abre = true
            this.esteId = id
            this.$emit('abrirDetalles', true)
            this.$emit('cambiaID', id)
        },
        ver(sel, secc){
            if(sel === 'All works'){
                return true
            } else {
                return secc.includes(sel)
            }
        },
        cambia(sel){
            
            this.este = sel
        },
        orderSel(sel, index){
            if(this.este === sel){
                return '0'
            } else {
                return index + 1
            }
        },
        initScrollReveal() {
        // const sr = ScrollReveal();

        // // Define las opciones globales (opcional)
        // sr.reveal('.reveal-animation', {
        //   duration: 1000, // Duración de la animación
        //   distance: '50px', // Distancia de movimiento
        //   origin: 'bottom', // Origen de la animación (top, bottom, left, right)
        //   easing: 'ease-in-out', // Tipo de animación
        // });

        // // Aplica la animación a los elementos con la clase 'reveal-animation'
        const revealElements = document.querySelectorAll('.stepLi');
            // console.log(revealElements);
            
            const scrollRev = ScrollReveal({
                distance: "50px",
                duration: 500,
                delay: 150,
                reset: true
            })

            revealElements.forEach(element => {
                // console.log(element);
                scrollRev.reveal(element, {delay: 50, origin: "bottom"});
            });
            // scrollRev.reveal(".stepLi", {delay: 200, origin: "top"});

        },
        // handleIntersect(entries) {
        //     console.log('EEE', entries);
            
        //     entries.forEach((entry) => {
        //         console.log('entry', entry);

        //         entry.target.src = entry.target.dataset.src;
        //         if (entry.isIntersecting) {
        //             console.log(entry.target.id);
        //             entry.target.classList.add('active')
        //             this.activeIndex = parseInt(entry.target.dataset.index, 10);
        //         } else {
        //             entry.target.classList.remove('active')
        //         }
        //     });
        // },
        
    }
}
</script>
<style lang='scss' scoped>
#works{
    padding: 30px 0 70px;
    margin: 100px auto 50px;
    width: 100%;
    text-align: center;
    // background-color: #e2effb;
    // background: linear-gradient(#e2effb 10%, 92%, white 99%);
    // background: linear-gradient(271deg, #31494e 0%, #385e70 25%, #131313 75%);
    display: flex;
    flex-direction: column;
    position: relative;
    visibility: visible;

    h2{
        font-family: var(--roboto);
        font-size: 4rem;
        font-weight: 300;
        color: var(--white);
        padding-top: 70px;
        letter-spacing: 150px;
        transform: translateX(6%);
    }
    // h2{
    //     text-align: center;
    //     width: 100%;
    //     color: var(--white);
    //     font-size: 4rem;
    //     font-family: var(--roboto);
    //     font-weight: 100;
    //     margin: 0px auto 30px;
    //     line-height: 0;
    // }
    .baja{
        text-align: center;
        margin: auto;
        font-family: var(--roboto);
        font-size: 1.2rem;
        font-weight: 300;
        color: var(--white);
    }
    #divSel{
        transition: .3s all ease-in-out;
        position: absolute;
        top: 220px;
        left: 50%;
        transform: translateX(-50%);
        width: 250px;
        z-index: 10;

        #selec{
            height: 30px;
            list-style-type: none;
            margin: 20px auto;
            width: 200px;
            overflow: hidden;
            position: relative;
            box-sizing: border-box;
            padding: 0 10px;
            cursor: pointer;
            text-align: left;
            border-radius: 1em;
            background-color: var(--white);
            transition: .3s all ease-in-out;
            display: flex;
            flex-flow: column nowrap;
    
            &:after{
                content: '';
                position: absolute;
                top: 11px;
                right: 10px;
                border-left: 7px solid transparent;
                border-right:7px solid transparent;
                border-top: 7px solid #3694d7;
                border-bottom:7px solid transparent;
                transition: .3s all ease;
            }

            li.opt{
                color: var(--col-mediocampista);
                margin: 5px auto;
                width: 100%;
                height: 30px;
                padding: 0 5px;
                display: block;

                &:hover{
                    color: #3694d7;
                }
            }
            &.open{
                height: auto;
                &:after{
                    top: 4px;
                    border-top: 7px solid transparent;
                    border-bottom: 7px solid #3694d7;
                }
            }
        }
    }
    
    ul#ulWorks{
        width: 75%;
        margin: 100px auto;
        list-style: none;
        display: flex;
        justify-content: center;
        flex-flow: row wrap;
        align-items: flex-start;
        align-content: flex-start;
        gap: 0px 4%;
        padding-inline-start: 0px;
    
        li.stepLi{
            width: 47%;
            display: flex;
            justify-content: center;
            flex-flow: column nowrap;
            align-items: center;
            align-content: center;
            padding: 40px 10px 0;
            border-bottom: .5px solid var(--white);
            cursor: pointer;
            visibility: visible;
            transform: translateY(60px);
            transition: all .5s ease;
            &:hover{
                // background-color: var(--white);
                background-color: #385e70;
            }
            
            &.si, &.active {
                opacity: 1;
                transform: translateY(0);
            }
            &.no {
                transform: translateY(60px);
            }

            .linkLi{
                width: 100%;
                text-decoration: none;
                cursor: pointer;
                &:link, &:visited, &:active {
                    color: var(--black);
                }
            }

            .conteLi{
                width: 100%;
                display: flex;
                align-content: center;
                justify-content: center;
                flex-flow: column nowrap;
                align-items: center;
                cursor: pointer;
            }

            .contImg{
                align-self: center;
                width: 95%;
                
                img, video{
                    width: 100%;
                    cursor: pointer;
                }
            }
            .contText{
                width: 95%;
                min-height: 60px;
                display: flex;
                justify-content: flex-start;
                flex-flow: row wrap;
                align-items: flex-start;
                align-content: flex-start;
                cursor: pointer;

                .titu{
                    font-size: 1.2rem;
                    font-weight: 300;
                    text-transform: uppercase;
                    width: 80%;
                    margin: 10px 0;
                    text-align: left;
                    flex-grow: 2;
                    color: var(--white);
                }
                .baja{
                    font-size: 1rem;
                    width: 90%;
                    text-align: left;
                    margin: 10px auto 30px;
                }
                // .base{
                //     display: flex;
                //     justify-content: center;
                //     align-content: flex-start;
                //     flex-flow: column nowrap;

                .link{
                    text-decoration: none;
                    font-family: var(--roboto);
                    font-size: 3rem;
                    font-weight: 100;
                    line-height: 49px;
                    color: var(--black);
                    margin: auto;
                    width: 50px;
                    height: 50px;
                    border-radius: 50%;
                    background-color: transparent;
                    display: inline-block;
                    -webkit-transition: .2s ease;
                    -moz-transition: .2s ease;
                    -o-transition: .2s ease;
                    transition: .2s ease;

                    &:link, &:visited, &:active {
                        color: var(--white);
                    }

                    .divCross {
                        width: 75px;
                        height: 75px;
                        border-radius: 50%;
                        margin: 0px auto -11px;
                        position: relative;
                        
                        .cross {
                            width: 2px;
                            height: 20px;
                            position: relative;
                            margin: auto;
                            background: #96cdff;

                            &:after {
                                content: "";
                                width: 20px;
                                height: 2px;
                                background: #96cdff;
                                position: absolute;
                                left: -9px;
                                top: 9px;
                            }
                        }
                    }
                    // }
                    .divSkills{
                        margin: auto;
                        width: 90%;
                        text-align: left;

                        img{
                            width: 45px;
                            margin: auto;
                        }
                    }
                }
            }
            &:hover{ // hover de .stepLi
                // .base{
                    // .titu{
                    //     color: #385e70;
                    // }
                    .link{
                        font-weight: 300;
                        animation: .6s baja infinite linear;
                    }
                // }
            }
            
        }
    }
}
@keyframes baja {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(89deg);
    }
}
@keyframes sube {
    0% {
        transform: rotate(90deg);
    }
    100% {
        transform: rotate(0);
    }
}
@media screen and (max-width: 900px){
    #works{
        h2{
            letter-spacing: 80px;
            font-size: 3rem;
        }
        ul#ulWorks{
            width: 85%;
            li.stepLi{
                .contText{
                    .titu{
                        font-size: 1.1rem;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                    .link{
                        width: 40px;
                        height: 40px;
                        line-height: 40px;
                        font-size: 2.5rem;
                    }
                }
            }
        }
    }
}
@media screen and (max-width: 600px){
    #works{
        margin: 150px auto 50px;
        h2{
            font-size: 2.5rem;
            letter-spacing: 30px;
            padding-top: 0px;
        }
        .baja{
            width: 90%;
            font-size: 1rem;
        }
        #divSel{
            top: 170px;

            #selec{
                padding-inline-start: 10px;
            }
        }
        ul#ulWorks{
            width: 90%;
            flex-flow: column nowrap;
            align-content: center;
            margin: 60px auto;

            li.stepLi{
                width: 95%;
                align-self: center;
                min-height: unset;
                margin: 30px auto;
                padding: 10px 0 0;

                .conteLi{
                    flex-flow: column nowrap;
                }
                .contImg{
                    width: 100%;
                }
                .contText{
                    width: 100%;
                    flex-flow: row-reverse;

                    .titu{
                        width: 95%;
                        // font-size: 1.7rem;
                    }
                    .baja{
                        width: 95%;
                    }
                    .link{
                        margin: 10px auto;
                        margin-top: 0;
                        line-height: 40px;

                        .divSkills{
                            text-align: center;

                            img{
                                width: 35px;
                            }
                        }
                    }
                }
            }
        }
    }
}
@media screen and (max-width: 450px){
    #works{
        ul#ulWorks{
            li.stepLi{
                .contText{
                    .titu{
                        font-size: 1.2rem;
                    }
                }
            }
        }
    }
}
</style>